import React, {PureComponent} from 'react'
import {withStyles} from '@material-ui/core/styles/index';
import Button from "@material-ui/core/Button";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";

const styles = theme => ({
        buttonSection: {
        textAlign: 'center',
        marginTop: theme.spacing(1.5),
        marginBottom: theme.spacing(1),
    },
    iconButton: {
        minWidth: 40,
    }
});


class ShowMore extends PureComponent {
    state = {
        showLimit: 2,
    }

    onShowAll = () => {
        this.setState({showLimit: null})
    }

    render() {
        const {classes, onClick, style} = this.props;

        return (
            <div className={classes.buttonSection} style={style}>
                <Button variant="outlined" color="primary" size="small" className={classes.iconButton}
                        onClick={onClick}>
                    <FontAwesomeIcon size={'lg'} icon={['fal', 'chevron-down']}/>
                </Button>
            </div>
        )
    }
}

export default withStyles(styles)(ShowMore);
